import { Dialog, isWeb, useSafeArea } from '@my/ui'

type GroupPostCreationModalProps = {
  open: boolean
  onOpenChange: (value) => void
  children: React.ReactNode
}

export const GroupPostCreationModal = ({
  open,
  onOpenChange,
  children,
}: GroupPostCreationModalProps) => {
  const { top } = useSafeArea()

  const insets = isWeb ? { pt: "$3.5" } : { pt: top, pb: 0 }

  return (
    <Dialog modal open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal zIndex="$2" h="100%" {...insets}>
        <Dialog.Overlay
          key="overlay"
          animation="quick"
          bg="$overlay8"
          enterStyle={{ opacity: 0 }}
          exitStyle={{ opacity: 0 }}
        />

        <Dialog.Content
          width="100%"
          maxWidth={600}
          height="100%"
          borderRadius="$3"
          key="content"
          animation={[
            'quick',
            {
              opacity: {
                overshootClamping: true,
              },
            },
          ]}
          y={0}
          opacity={1}
          enterStyle={{ opacity: 0, y: 100 }}
          exitStyle={{ opacity: 0, y: 100 }}
          $gtSm={{
            maxHeight: 600
          }}
        >
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
